import { useContext, useEffect, useState } from 'react';

import { Progress } from '@material-tailwind/react';

import { appContext } from '../../../../AppContext';
import { trimString } from '../../../../utils/converter';
import { validationTime } from '../../../../utils/config';
import LoadingProgressBar from './LoadingProgressBar';

const FileProgress = ({ files, validatingFile }) => {
  const { validateState, validationComplete, validationLoader, validationStatus } =
    useContext(appContext);
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    if (validateState && !validationComplete) {
      setElapsedTime(0); // Reset when a new file starts validating

      const interval = setInterval(() => {
        setElapsedTime((prevTime) => {
          // Apply a formula to make progress slower over time
          const progressRatio = prevTime / (validationTime / 1000);
          const increment = 0.1 * (1 - progressRatio); // Decrease increment as progress increases

          // Update elapsedTime with diminishing increments
          return prevTime + increment;
        });
      }, 100);

      return () => clearInterval(interval);
    }
  }, [validateState, validatingFile]);

  // Calculate the percentage
  const progressPercentage = Math.floor((elapsedTime / (validationTime / 1000)) * 100);
  const totalFileLength: number = files.length;

  const getValidatingFileIndex = () => {
    return files.findIndex((file) => file.file.name === validatingFile) + 1;
  };

  return (
    <>
      {/* Validating and not complete */}
      {validationLoader && validateState && !validationComplete && (
        <div className="flex flex-col justify-center h-[90px] w-[calc(100%-4px)] text-sm font-normal text-core-grey-80">
          <p>{trimString(validatingFile)}</p>
          <div className="my-4">
            {/* <Progress
            value={progressPercentage}
            variant="filled"
            size="sm"
            className="[&>div]:bg-minima-orange-2023"
          /> */}
            <LoadingProgressBar />
          </div>
          {validationStatus !== '' && <div>{validationStatus}</div>}
          <p className="text-right">
            Verifying{' '}
            <span className="text-white">
              {getValidatingFileIndex()}/{totalFileLength}
            </span>
          </p>
        </div>
      )}

      {/* 
      {!validateState && validationComplete && (
        <div className="flex  justify-center flex-col h-[90px] w-[calc(100%-4px)] border-2 border-[var(--core-black-contrast-3)] rounded">
          <div className="flex justify-center items-center h-full">
            <p>Validation Complete</p>
            <CheckCircleIcon className="ml-2 text-green-500" />
          </div>
        </div>
      )} */}
    </>
  );
};

export default FileProgress;
